import React from 'react';

import { Image } from 'antd';
import OptionalLink from "../OptionalLink";
import { OptionsButton } from "../Buttons";
import StatsIcons from "../StatsIcons";
import Badge, { BadgeInterface } from "../Badge";
import './style.scss';

interface propsInterface {
  image: string;
  title?: string;
  link?: string;
  children?: React.ReactNode;
  stats?: React.ReactNode[];
  options?: React.ReactNode[];
  badge?: BadgeInterface['badge'];
  ribbon?: BadgeInterface['ribbon'];
  preview?: boolean;
  className?: string;
  fallback?: string;
  size?: 'small' | 'medium' | 'large';
  labels?: React.ReactNode[];
}

const CardImage = (
  {
    title,
    image,
    link,
    children,
    className,
    stats,
    options,
    badge,
    ribbon,
    size,
    labels,
    fallback,
    preview = false
  }: propsInterface) => {
  let extraClassName = '';
  extraClassName += className ? ` ${className}` : '';
  extraClassName += size ? ` v-card-image--${size}` : '';

  const renderLabels = () => {
    if (!labels || !labels.length) {
      return;
    }

    return (
      <div className='v-card-image-labels'>
        {labels}
      </div>
    );
  }

  return (
    <div className={`v-card-image ${extraClassName}`}>
      <Badge badge={badge} ribbon={ribbon}>
        <div className='o-img-box'>
          {renderLabels()}

          <OptionalLink link={link}>
            <div>
              <Image
                className='v-card-image-img'
                alt={`card ${image}`}
                src={image || 'error'}
                preview={preview}
                fallback={fallback}
              />
            </div>
          </OptionalLink>
        </div>

        <div className='o-body'>
          {title &&
            <OptionalLink link={link}>
              <h3 className='o-title'>{title}</h3>
            </OptionalLink>
          }

          {children}
        </div>

        <div className='o-footer'>
          {stats && <StatsIcons icons={stats} />}

          {options && options.length > 0 && <OptionsButton key='settings' options={options} /> }
        </div>
      </Badge>
    </div>
  );
}

export default CardImage;
